module.exports = __webpack_public_path__ + "img/services-icon1.494554f8.png";